import { combineReducers } from 'redux';
import * as Product from './Product';
import * as routing from './routing';
import * as redux from './redux';

module.exports = {
  reducer: redux.reducer,
  ...Product,
  ...routing
}



// WEBPACK FOOTER //
// ./modules/productIntroduction/index.js